import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

const IncomingIcon = props => {
  const { title, width, height, toneDown } = props;
  return (
    <svg
      className={styles.incoming.withModifier({ 'tone-down': toneDown })}
      height={height}
      width={width}
      viewBox="0 0 29 11"
    >
      {title && <title>{title}</title>}
      <path
        d="M1 0L4 0 4 3 1 3 1 0ZM5 0L8 0 8 3 5 3 5 0ZM0 4L3 4 3 7 0 7 0 4ZM4 4L7 4 7 7 4 7 4 4ZM8 4L11 4 11 7 8 7 8 4ZM0 8L3 8 3 11 0 11 0 8ZM4 8L7 8 7 11 4 11 4 8ZM8 8L11 8 11 11 8 11 8 8ZM17 5L29 5 29 7 17 7 17 5ZM22 1L25 1 20 5 17 5 22 1ZM17 7L20 7 25 11 22 11 17 7Z"
        fill="#FED735"
      />
    </svg>
  );
};

const { string, number, bool } = PropTypes;
IncomingIcon.propTypes = {
  title: string,
  height: number,
  width: number,
  toneDown: bool,
};

IncomingIcon.defaultProps = {
  height: 12,
  width: 30,
  title: undefined,
  toneDown: false,
};

export default IncomingIcon;
